import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { init as initEmailJS } from 'emailjs-com'

// Initialize Firebase (import only, no need to use the exports)
import './firebase/config'

// Initialize EmailJS with your user ID
try {
  console.log('Initializing EmailJS with User ID:', import.meta.env.VITE_EMAILJS_USER_ID ? 'exists' : 'missing');
  initEmailJS(import.meta.env.VITE_EMAILJS_USER_ID);
  console.log('EmailJS initialized successfully');
} catch (error) {
  console.error('Failed to initialize EmailJS:', error);
}

const rootElement = document.getElementById('root')!

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
}
